import { Injectable } from '@angular/core';
import { HttpService } from '@app/shared/services/http/http.service';
import { UrlService } from '@app/shared/services/url/url.service';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfilesService {
  constructor(private _httpService: HttpService, private _urlService: UrlService) {}

  getProfiles(): Observable<any> {
    const url = this._urlService.getUrl('COLLECT.getProfileGroups');
    return this._httpService.get(url, null).pipe(catchError((error: any) => throwError(error)));
  }

  deleteProfile(id: string): Observable<any> {
    const url = this._urlService.getUrl('COLLECT.deleteGroupProfile', { id });
    return this._httpService.delete(url, null).pipe(catchError((error: any) => throwError(error)));
  }

  updatePermissions(data: any): Observable<any> {
    const url = this._urlService.getUrl('COLLECT.updateGroupProfile');
    return this._httpService.put(url, data).pipe(catchError((error: any) => throwError(error)));
  }

  registerPermission(data: any): Observable<any> {
    const url = this._urlService.getUrl('COLLECT.postGroupProfile');
    return this._httpService.post(url, data).pipe(catchError((error: any) => throwError(error)));
  }

  listPermissionRoles(): Observable<any> {
    const url = this._urlService.getUrl('COLLECT.listProfileRoles');
    return this._httpService.get(url, {}).pipe(catchError((error: any) => throwError(error)));
  }
}
